import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CustomIconsService, ExtRouteService, HeaderComponent } from '@comparit/core';
import { NavigatorComponent } from '@comparit/shared';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';

@Component({
  imports: [HeaderComponent, MatSidenavModule, RouterOutlet, NavigatorComponent],
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShellComponent {
  private readonly _customIconsService = inject(CustomIconsService);
  private readonly _extRouteService = inject(ExtRouteService);

  constructor() {
    this._customIconsService.init();
  }

  protected showNavigator = computed(() => !this._extRouteService.url().endsWith('step1'));
}
